module.exports = __webpack_public_path__ + "static/media/news-press-m.368af3d6.png";